// import React from 'react';
// import { 
//   Card, 
//   CardContent, 
//   Typography, 
//   Chip, 
//   Box, 
//   Grid 
// } from '@mui/material';
// import { 
//   Computer, 
//   LocationOn, 
//   Schedule, 
//   NetworkCheck 
// } from '@mui/icons-material';

// const VMOverview = ({ vmData, currentUsage }) => {
//   const getStatusColor = (status) => {
//     switch (status.toLowerCase()) {
//       case 'running':
//         return 'success';
//       case 'stopped':
//         return 'error';
//       case 'starting':
//         return 'warning';
//       default:
//         return 'default';
//     }
//   };

//   return (
//     <Card sx={{ width: '100%', mb: 3 }}>
//       <CardContent sx={{ p: 3 }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
//           <Box display="flex" alignItems="center" gap={2}>
//             <Computer sx={{ fontSize: 32, color: 'primary.main' }} />
//             <Box>
//               <Typography variant="h5" component="h2" fontWeight="bold">
//                 {vmData.resourceName}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Virtual Machine Instance
//               </Typography>
//             </Box>
//           </Box>
//           <Chip 
//             label={vmData.status}
//             color={getStatusColor(vmData.status)}
//             variant="outlined"
//             sx={{ fontWeight: 'bold' }}
//           />
//         </Box>

//         <Grid container spacing={12} mb={3}>
//           <Grid item xs={12} md={3} lg={3}>
//             <Box display="flex" alignItems="center" gap={1} mb={1}>
//               <Computer sx={{ fontSize: 16, color: 'text.secondary' }} />
//               <Typography variant="subtitle2" fontWeight="bold">Size</Typography>
//             </Box>
//             <Typography variant="body2" color="text.secondary" mb={1}>
//               {vmData.size}
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               2 vCPUs, 8 GB RAM
//             </Typography>
//           </Grid>

//           <Grid item xs={12} md={6} lg={3}>
//             <Box display="flex" alignItems="center" gap={1} mb={1}>
//               <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
//               <Typography variant="subtitle2" fontWeight="bold">Location</Typography>
//             </Box>
//             <Typography variant="body2" color="text.secondary">
//               {vmData.location}
//             </Typography>
//           </Grid>

//           <Grid item xs={12} md={6} lg={3}>
//             <Box display="flex" alignItems="center" gap={1} mb={1}>
//               <Schedule sx={{ fontSize: 16, color: 'text.secondary' }} />
//               <Typography variant="subtitle2" fontWeight="bold">Uptime</Typography>
//             </Box>
//             <Typography variant="body2" color="text.secondary">
//               {vmData.uptime}
//             </Typography>
//           </Grid>

//           <Grid item xs={12} md={6} lg={3}>
//             <Box display="flex" alignItems="center" gap={1} mb={1}>
//               <NetworkCheck sx={{ fontSize: 16, color: 'text.secondary' }} />
//               <Typography variant="subtitle2" fontWeight="bold">Network</Typography>
//             </Box>
//             <Typography variant="caption" color="text.secondary" display="block">
//               Public: {vmData.publicIP}
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               Private: {vmData.privateIP}
//             </Typography>
//           </Grid>
//         </Grid>

// {/* 
//         <Box sx={{ pt: 2, borderTop: 1, borderColor: 'divider' }}>
//           <Box display="flex" justifyContent="space-between" alignItems="center">
//             <Typography variant="subtitle2" fontWeight="bold">
//               Current Resource Usage
//             </Typography>
//             <Box display="flex" gap={3}>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <Box sx={{ width: 8, height: 8, bgcolor: 'primary.main', borderRadius: '50%' }} />
//                 <Typography variant="caption">CPU: {currentUsage.cpu}%</Typography>
//               </Box>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <Box sx={{ width: 8, height: 8, bgcolor: 'success.main', borderRadius: '50%' }} />
//                 <Typography variant="caption">Memory: {currentUsage.memory}%</Typography>
//               </Box>
//               <Box display="flex" alignItems="center" gap={1}>
//                 <Box sx={{ width: 8, height: 8, bgcolor: 'secondary.main', borderRadius: '50%' }} />
//                 <Typography variant="caption">Network: {currentUsage.network}%</Typography>
//               </Box>
//             </Box>
//           </Box>
//         </Box> */}
//       </CardContent>
//     </Card>
//   );
// };

// export default VMOverview;

// Updated VMOverview that accepts both static and dynamic data
// Dynamic VMOverview component - API data only
import React, { useState, useEffect } from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Chip, 
  Box, 
  Grid,
  CircularProgress
} from '@mui/material';
import { 
  Computer, 
  LocationOn, 
  Schedule, 
  NetworkCheck 
} from '@mui/icons-material';
import { api } from "../services/api";
import {PropTypes} from 'prop-types';

const VMOverview = ({ resource }) => {
  const [resourceDetails, setResourceDetails] = useState([]);
  const [viewResponse, setViewResponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Define all helper functions at the top of the component
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'running':
      case 'active':
        return 'success';
      case 'stopped':
      case 'inactive':
        return 'error';
      case 'starting':
      case 'pending':
        return 'warning';
      default:
        return 'default';
    }
  };

  // Helper functions for API data
  const getFieldData = (fieldName) => {
    if (!resourceDetails || !Array.isArray(resourceDetails) || resourceDetails.length === 0) {
      return 'N/A';
    }
    
    const field = resourceDetails.find(detail => 
      detail?.fieldName?.toLowerCase().includes(fieldName.toLowerCase())
    );
    return field?.fieldData || 'N/A';
  };

  const getVMSizeDetails = () => {
    if (!resourceDetails || !Array.isArray(resourceDetails) || resourceDetails.length === 0) {
      return 'N/A';
    }
    
    const sizeField = resourceDetails.find(detail => 
      detail?.fieldName?.toLowerCase().includes('size') || 
      detail?.fieldName?.toLowerCase().includes('sku') ||
      detail?.fieldName?.toLowerCase().includes('instance') ||
      detail?.fieldName?.toLowerCase().includes('vm')
    );
    return sizeField?.fieldData || 'N/A';
  };

  const getLocation = () => {
    if (!resourceDetails || !Array.isArray(resourceDetails) || resourceDetails.length === 0) {
      return 'N/A';
    }
    
    const locationField = resourceDetails.find(detail => 
      detail?.fieldName?.toLowerCase().includes('location') || 
      detail?.fieldName?.toLowerCase().includes('region')
    );
    return locationField?.fieldData || 'N/A';
  };

  const getUptime = () => {
    if (!resourceDetails || !Array.isArray(resourceDetails) || resourceDetails.length === 0) {
      return 'N/A';
    }
    
    const uptimeField = resourceDetails.find(detail => 
      detail?.fieldName?.toLowerCase().includes('uptime') ||
      detail?.fieldName?.toLowerCase().includes('created') ||
      detail?.fieldName?.toLowerCase().includes('start') ||
      detail?.fieldName?.toLowerCase().includes('date')
    );
    return uptimeField?.fieldData || 'N/A';
  };

  const getCPUInfo = () => {
    const cpu = getFieldData('cpu') || getFieldData('vcpu') || getFieldData('core') || getFieldData('processor');
    return cpu !== 'N/A' ? `${cpu} vCPUs` : '';
  };

  const getRAMInfo = () => {
    const memory = getFieldData('memory') || getFieldData('ram');
    return memory !== 'N/A' ? `${memory} GB RAM` : '';
  };

  const getPublicIP = () => {
    const publicIP = getFieldData('publicip') || getFieldData('public') || getFieldData('external');
    return publicIP !== 'N/A' ? publicIP : null;
  };

  const getPrivateIP = () => {
    const privateIP = getFieldData('privateip') || getFieldData('private') || getFieldData('internal');
    return privateIP !== 'N/A' ? privateIP : null;
  };

  const isValidIP = (ip) => 
    ip !== null && ip !== undefined && ip !== "" && ip !== "N/A";

  // UseEffect for fetching data
  useEffect(() => {
    if (!resource?.resourceId) {
      setError('No resource ID provided');
      return;
    }
    
    const fetchDetails = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await api.get(
          `/api/Resources/viewResourceRequest/${resource.resourceId}`,
          {
            headers: {
              "X-CORRELATION-ID": "0d89a8fe-6a3f-46e6-8bde-72daf869b07c",
            },
          }
        );
        
       
        
        setResourceDetails(response.data.resourceRequestDetails || []);
        setViewResponse(response.data || {});
      } catch (error) {
        console.error("Error fetching resource details:", error);
        setError('Failed to fetch resource details');
      } finally {
        setLoading(false);
      }
    };
    
    fetchDetails();
  }, [resource?.resourceId]);

  // Loading state
  if (loading) {
    return (
      <Card sx={{ width: '100%', mb: 3 }}>
        <CardContent sx={{ p: 3, textAlign: 'center' }}>
          <CircularProgress size={40} sx={{ mb: 2 }} />
          <Typography>Loading VM details...</Typography>
        </CardContent>
      </Card>
    );
  }

  // Error state
  if (error) {
    return (
      <Card sx={{ width: '100%', mb: 3 }}>
        <CardContent sx={{ p: 3 }}>
          <Typography color="error" variant="h6">Error</Typography>
          <Typography color="text.secondary">{error}</Typography>
        </CardContent>
      </Card>
    );
  }

  // Main render - API-based data only
  return (
    <Card sx={{ width: '100%', mb: 3 }}>
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box display="flex" alignItems="center" gap={2}>
            <Computer sx={{ fontSize: 32, color: 'primary.main' }} />
            <Box>
              <Typography variant="h5" component="h2" fontWeight="bold">
                {resource?.applicationName || viewResponse?.applicationName || 'Virtual Machine'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Virtual Machine Instance
              </Typography>
            </Box>
          </Box>
          <Chip 
            label={resource?.status || viewResponse?.status || 'Unknown'}
            color={getStatusColor(resource?.status || viewResponse?.status)}
            variant="outlined"
            sx={{ fontWeight: 'bold' }}
          />
        </Box>

        <Grid container c mb={3} spacing={16}>
          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Computer sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="subtitle2" fontWeight="bold">Size</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" mb={1}>
              {getVMSizeDetails()}
            </Typography>
            {/* <Typography variant="caption" color="text.secondary">
                           {[getCPUInfo(), getRAMInfo()].filter(Boolean).join(', ') || 'Specs not available'}
            </Typography> */}
          </Grid>

          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="subtitle2" fontWeight="bold">Location</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {getLocation()}
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Schedule sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="subtitle2" fontWeight="bold">Created</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              {getUptime()}
            </Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <NetworkCheck sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="subtitle2" fontWeight="bold">Network</Typography>
            </Box>
            {isValidIP(getPublicIP()) && (
              <Typography variant="caption" color="text.secondary" display="block">
                Public: {getPublicIP()}
              </Typography>
            )}
            {isValidIP(getPrivateIP()) && (
              <Typography variant="caption" color="text.secondary" display="block">
                Private: {getPrivateIP()}
              </Typography>
            )}
            {isValidIP(viewResponse?.publicIP) && (
              <Typography variant="caption" color="text.secondary" display="block">
                Public: {viewResponse.publicIP}
              </Typography>
            )}
            {isValidIP(viewResponse?.privateIP) && (
              <Typography variant="caption" color="text.secondary" display="block">
                Private: {viewResponse.privateIP}
              </Typography>
            )}
            {!isValidIP(getPublicIP()) && !isValidIP(getPrivateIP()) && 
             !isValidIP(viewResponse?.publicIP) && !isValidIP(viewResponse?.privateIP) && (
              <Typography variant="caption" color="text.secondary">
                No IP addresses available
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* Additional Resource Details */}
        {resourceDetails && resourceDetails.length > 0 && (
          <Box sx={{ pt: 2, borderTop: 1, borderColor: 'divider', mb: 2 }}>
            <Typography variant="subtitle2" fontWeight="bold" mb={2}>
              Resource Details
            </Typography>
            <Grid container spacing={3}>
              {resourceDetails
                .filter(detail => 
                  detail?.fieldName && detail?.fieldData && 
                  !['size', 'sku', 'location', 'region', 'cpu', 'memory', 'ram', 'publicip', 'privateip'].some(keyword =>
                    detail?.fieldName?.toLowerCase().includes(keyword)
                  )
                )
                .slice(0, 8) // Show first 8 additional details
                .map((detail, index) => (
                  <Grid item xs={12} md={6} key={index}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ textTransform: "capitalize" }}>
                        {detail?.fieldName?.replaceAll(/([A-Z])/g, ' $1').trim()}:
                      </Typography>
                      <Typography variant="body2" color="primary.main" fontWeight="bold">
                        {detail?.fieldData || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </Box>
        )}

        {/* Price Information */}
        {viewResponse?.totalPrice && (
          <Box sx={{ pt: 2, borderTop: 1, borderColor: 'divider' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle2" fontWeight="bold">
                Pricing Information
              </Typography>
              <Typography variant="h6" color="primary.main" fontWeight="bold">
                ${viewResponse.totalPrice}
              </Typography>
            </Box>
            <Typography variant="caption" color="text.secondary">
              Total Forecasted Price
            </Typography>
          </Box>
        )}

        {/* Debug Information (Remove in production) */}
        {/* {process.env.NODE_ENV === 'development' && (
          <Box sx={{ pt: 2, borderTop: 1, borderColor: 'divider', mt: 2 }}>
            <Typography variant="subtitle2" fontWeight="bold" mb={1}>
              Debug Info (Development Only)
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              Resource Details Count: {resourceDetails?.length || 0}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              View Response Keys: {Object.keys(viewResponse).join(', ')}
            </Typography>
          </Box>
        )} */}
      </CardContent>
    </Card>
  );
};
VMOverview.propTypes = {
  resource: PropTypes.shape({
    resourceId: PropTypes.string.isRequired,
    applicationName: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

export default VMOverview;





